// Returns an embeddable player URL, or null when none can be derived
// (e.g. a draft entry's empty url field).

const parseUrl = (url) => {
  try {
    return new URL(url.includes('://') ? url : `https://${url}`);
  } catch {
    return null;
  }
};

const bareHost = (parsed) => parsed.hostname.replace(/^www\./, '');

const pathSegments = (parsed) => parsed.pathname.split('/').filter(Boolean);

const youtube = {
  matches: (parsed) => bareHost(parsed) === 'youtu.be' || bareHost(parsed).endsWith('youtube.com'),
  embedUrl: (parsed) => {
    const segments = pathSegments(parsed);
    if (segments[0] === 'embed') {
      return segments[1] ? `${parsed.origin}${parsed.pathname}?rel=0` : null;
    }
    const videoId =
      bareHost(parsed) === 'youtu.be'
        ? segments[0]
        : parsed.searchParams.get('v') ||
          (['shorts', 'v', 'live'].includes(segments[0]) && segments[1]);
    return videoId ? `https://www.youtube.com/embed/${videoId}?rel=0` : null;
  }
};

const vimeo = {
  matches: (parsed) => bareHost(parsed).endsWith('vimeo.com'),
  embedUrl: (parsed) => {
    if (parsed.hostname === 'player.vimeo.com') {
      return parsed.href;
    }
    // The video id is the last numeric path segment in every vimeo url shape.
    const videoId = pathSegments(parsed)
      .reverse()
      .find((segment) => /^\d+$/.test(segment));
    return videoId ? `https://player.vimeo.com/video/${videoId}` : null;
  }
};

const providers = [youtube, vimeo];

export const formatVideoUrl = (url) => {
  if (!url) return null;
  const parsed = parseUrl(url);
  if (!parsed) return null;
  const provider = providers.find(({ matches }) => matches(parsed));
  return provider ? provider.embedUrl(parsed) : url;
};
